module.exports = __webpack_public_path__ + "assets/c40854ff6a57a224287e7edf6fb26e8b.mp3";